import type { PolicyDocument } from '../../types/policy';
import { company as c } from '../company';

export const returnsPolicy: PolicyDocument = {
  title: 'Return & Refund Policy',
  lead: `Not the right fit? You have ${c.returnWindowDays} days to return it.`,
  sections: [
    {
      id: 'window',
      heading: `${c.returnWindowDays}-day returns`,
      blocks: [
        `You may return products purchased directly from ${c.brand} within ${c.returnWindowDays} days of delivery. To be eligible, products must be:`,
        {
          list: [
            'in like-new, resellable condition, free of scratches, residue, adhesive or water deposits;',
            'returned with the original packaging, Magnetic Mount System bases, cables, guides and all included accessories;',
            'accompanied by your order number.',
          ],
        },
      ],
    },
    {
      id: 'how',
      heading: 'How to start a return',
      blocks: [
        `Email ${c.supportEmail} with your order number and the items you wish to return. We will reply with a Return Authorization (RA) number and return instructions. Returns sent without an RA number, or to any other address, may not be accepted or refunded.`,
      ],
    },
    {
      id: 'costs',
      heading: 'Return shipping',
      blocks: [
        'For change-of-mind returns, you are responsible for return shipping costs, and original shipping charges are non-refundable. If free shipping was applied to your order, the actual cost of outbound shipping may be deducted from your refund. We recommend a trackable, insured shipping method — we are not responsible for returns lost in transit.',
        'If your item arrived damaged, defective or incorrect, we cover the cost of the replacement — see our Shipping Policy.',
      ],
    },
    {
      id: 'opened',
      heading: 'Used or incomplete returns',
      blocks: [
        `Products that have been installed, submerged, used, or returned with missing parts or packaging may be refused or subject to a restocking fee of up to ${c.restockingFeePct}% of the item price. Products showing damage, misuse, modification or excessive wear are not eligible for a refund.`,
      ],
    },
    {
      id: 'bundles',
      heading: 'Lighting systems',
      blocks: [
        'Complete Lighting Systems are priced as a set. You may return an entire system for a refund of the price paid. If you return only part of a system, the lights you keep will be re-priced at the applicable individual (Build Your Own) price, and the difference will be deducted from your refund.',
      ],
    },
    {
      id: 'refunds',
      heading: 'Refunds',
      blocks: [
        'Once your return is received and inspected, we will email you about its status. Approved refunds are issued to the original payment method within 5–10 business days. Your bank may take additional time to post the refund.',
      ],
    },
    {
      id: 'exchanges',
      heading: 'Exchanges',
      blocks: ['The fastest way to exchange is to return the original item for a refund and place a new order.'],
    },
    {
      id: 'final',
      heading: 'Non-returnable items',
      blocks: [
        {
          list: [
            'Items marked final sale or clearance.',
            'Gift cards and free promotional items.',
            'Products purchased from unauthorized resellers or marketplaces.',
          ],
        },
      ],
    },
    {
      id: 'defective',
      heading: 'Defects after 30 days',
      blocks: ['Manufacturing defects that appear after the return window are covered by our Limited Warranty. See Warranty Information.'],
    },
  ],
};
